import { isActive } from '@app/BottomNav'
import { useI18n } from '@i18n/I18nProvider'
import type { MessageKey } from '@i18n/messages'
import { Button } from '@ui/Button'
import { Screen } from '@ui/Screen'
import { Link, Route, Switch, useLocation } from 'wouter'
import { LoginPage } from './LoginPage'
import { MagicPlacesPage } from './MagicPlacesPage'
import { ReportsPage } from './ReportsPage'
import { useStaffSession } from './StaffSession'
import { SummaryPage } from './SummaryPage'
import { TreeHistoryPage } from './TreeHistoryPage'
import { TreesPage } from './TreesPage'

// Rutas RELATIVAS a /panel (la ruta del panel va anidada en AppRoutes).
export const PANEL_TABS: { href: string; label: MessageKey }[] = [
	{ href: '/', label: 'panel.summary' },
	{ href: '/arboles', label: 'panel.trees' },
	{ href: '/avisos', label: 'panel.reports' },
	{ href: '/lugares-magicos', label: 'panel.magic' },
]

const PanelTabs = () => {
	const { t } = useI18n()
	const [location] = useLocation()
	return (
		<nav
			aria-label={t('panel.sections')}
			className="mb-6 grid grid-cols-2 gap-1 rounded-2xl bg-sage-200 p-1 sm:grid-cols-4"
		>
			{PANEL_TABS.map((tab) => {
				const active = isActive(tab.href, location)
				return (
					<Link
						key={tab.href}
						href={tab.href}
						aria-current={active ? 'page' : undefined}
						className={`flex min-h-12 items-center justify-center rounded-xl font-semibold ${active ? 'bg-white text-forest-800 shadow-sm' : 'text-olive-900'}`}
					>
						{t(tab.label)}
					</Link>
				)
			})}
		</nav>
	)
}

const PanelContent = () => {
	const { t } = useI18n()
	const { session, signOut } = useStaffSession()
	if (!session) return <LoginPage />
	return (
		<Screen title={t('panel.title')}>
			<div className="-mt-3 mb-4 flex flex-wrap items-center justify-between gap-2">
				<p className="text-earth-800">{t('panel.hello', { name: session.user.name })}</p>
				<Button variant="ghost" onClick={signOut}>
					{t('panel.signOut')}
				</Button>
			</div>
			<PanelTabs />
			<Switch>
				<Route path="/arboles/:code">{(params) => <TreeHistoryPage code={params.code} />}</Route>
				<Route path="/arboles" component={TreesPage} />
				<Route path="/avisos" component={ReportsPage} />
				<Route path="/lugares-magicos" component={MagicPlacesPage} />
				<Route path="/">{() => <SummaryPage />}</Route>
			</Switch>
		</Screen>
	)
}

// Panel de seguimiento de la asociación (consulta y moderación de lugares mágicos). No aparece
// en la navegación de los caminantes: se entra por /panel con una cuenta del personal (spec
// `staff-auth`). La sesión la da StaffSessionProvider, en AppProviders.
export const PanelApp = () => <PanelContent />
